<template>
  <li class="grid-item sm-pr2">
    <router-link :to="postlink" active-class="nope" class="sm-flex hover-green pb2">
      <div class="thumb order-1">
        <responsive-image class="grid-item-img" :image="thumbnail" :max-size="3"/>
      </div>
      <div class="sidebar project-title text-inherit line-height-3 pt1 sm-pt0 h6 self-start sticky top-h order-0 flex-none mb3 sm-mb0">
        <h3 class="mt1 mb0">{{ title }}</h3>
        <p v-if="byline" class="m0">{{ byline }}</p>
      </div>
    </router-link>
  </li>
</template>

<script>
  export default {
    name: 'grid-item',
    props: {
      post: {
        type: Object,
        required: true
      }
    },
    computed: {
      postlink () {
        return this.post.link.replace(window.location.origin, '')
      },
      thumbnail () {
        return this.post.acf.thumbnail || this.post.acf.gallery[0]
      },
      title () {
        return this.post.title.rendered
      },
      byline () {
        const { byline } = this.post.acf
        if (!byline || !byline.length) return false
        return byline
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/partials/GridItem.vue